import type { Wws_WeddingWebsiteV2 } from '../types/graphql';

interface GetCoupleNamesProps {
  weddingWebsiteResult: Wws_WeddingWebsiteV2;
}

export function getCoupleNames({
  weddingWebsiteResult,
}: GetCoupleNamesProps): string[] | null {
  const { firstName, fianceFirstName, reverseCoupleNameOrder = false } = weddingWebsiteResult;
  if (!firstName || !fianceFirstName) {
    return null;
  }

  return reverseCoupleNameOrder ? [fianceFirstName, firstName] : [firstName, fianceFirstName];
}
